import template from '../ui/templates/modal/kwls-login.hbs';
import { kwls } from '@config';

class ModalKwlsLogin {
  constructor (opts) {
    this.opts = $.extend(
      {
        userId: INKIVE.C.USER.id,
        userName: Base64.decode(INKIVE.C.USER.nickname),

        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $.parseHTML(this.opts.wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    this.$wrapper.append(
      template({
        user_name: this.opts.userName
      })
    );
  }

  getFormHtml () {
    return this.$wrapper;
  }

  sendRequest (callback) {
    $.ajax({
      url: this.opts.server + '/login',
      type: 'POST',
      headers: kwls.headers,
      error: function () {
        INKIVE.Modal.togglePageLoader(false);
        INKIVE.Modal.alertMessage(
          INKIVE.TemplatesHelper('alert_default', {
            message: 'modal.kwls_login.invalid_credentials'
          })
        );
      },
      success: callback,
      data: {
        username: this.$wrapper.find('[name="kw_user_name"]').val(),
        password: this.$wrapper.find('[name="kw_password"]').val()
      }
    });
  }
}

module.exports = ModalKwlsLogin;
